import { supabase } from '../lib/supabase';

const companySettingsService = {
  /**
   * Get company settings (there should only be one record)
   */
  async getSettings() {
    const { data, error } = await supabase?.from('company_settings')?.select('*')?.single();
    
    if (error) {
      if (error?.code === 'PGRST116') {
        // No settings exist yet
        return null;
      }
      throw error;
    }
    
    // Convert snake_case to camelCase
    return {
      id: data?.id,
      companyName: data?.company_name,
      legalEntityName: data?.legal_entity_name,
      registrationNumber: data?.registration_number,
      taxId: data?.tax_id,
      
      streetAddress: data?.street_address,
      city: data?.city,
      stateProvince: data?.state_province,
      postalCode: data?.postal_code,
      country: data?.country,
      
      phoneNumber: data?.phone_number,
      email: data?.email,
      websiteUrl: data?.website_url,
      
      logoUrl: data?.logo_url,
      primaryColor: data?.primary_color,
      secondaryColor: data?.secondary_color,
      
      fiscalYearStartMonth: data?.fiscal_year_start_month,
      currency: data?.currency,
      timezone: data?.timezone,
      
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  /**
   * Create or update company settings
   */
  async saveSettings(settings) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    // Check if settings already exist
    const existing = await this.getSettings();
    
    // Convert camelCase to snake_case
    const dbSettings = {
      company_name: settings?.companyName,
      legal_entity_name: settings?.legalEntityName,
      registration_number: settings?.registrationNumber,
      tax_id: settings?.taxId,
      
      street_address: settings?.streetAddress,
      city: settings?.city,
      state_province: settings?.stateProvince,
      postal_code: settings?.postalCode,
      country: settings?.country,
      
      phone_number: settings?.phoneNumber,
      email: settings?.email,
      website_url: settings?.websiteUrl,
      
      logo_url: settings?.logoUrl,
      primary_color: settings?.primaryColor,
      secondary_color: settings?.secondaryColor,
      
      fiscal_year_start_month: settings?.fiscalYearStartMonth,
      currency: settings?.currency,
      timezone: settings?.timezone,
      
      updated_by: user?.id
    };

    if (existing) {
      // Update existing settings
      const { data, error } = await supabase?.from('company_settings')?.update(dbSettings)?.eq('id', existing?.id)?.select()?.single();
      
      if (error) throw error;
      
      return {
        id: data?.id,
        companyName: data?.company_name,
        legalEntityName: data?.legal_entity_name,
        registrationNumber: data?.registration_number,
        taxId: data?.tax_id,
        
        streetAddress: data?.street_address,
        city: data?.city,
        stateProvince: data?.state_province,
        postalCode: data?.postal_code,
        country: data?.country,
        
        phoneNumber: data?.phone_number,
        email: data?.email,
        websiteUrl: data?.website_url,
        
        logoUrl: data?.logo_url,
        primaryColor: data?.primary_color,
        secondaryColor: data?.secondary_color,
        
        fiscalYearStartMonth: data?.fiscal_year_start_month,
        currency: data?.currency,
        timezone: data?.timezone,
        
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } else {
      // Create new settings
      dbSettings.created_by = user?.id;
      
      const { data, error } = await supabase?.from('company_settings')?.insert(dbSettings)?.select()?.single();
      
      if (error) throw error;
      
      return {
        id: data?.id,
        companyName: data?.company_name,
        legalEntityName: data?.legal_entity_name,
        registrationNumber: data?.registration_number,
        taxId: data?.tax_id,
        
        streetAddress: data?.street_address,
        city: data?.city,
        stateProvince: data?.state_province,
        postalCode: data?.postal_code,
        country: data?.country,
        
        phoneNumber: data?.phone_number,
        email: data?.email,
        websiteUrl: data?.website_url,
        
        logoUrl: data?.logo_url,
        primaryColor: data?.primary_color,
        secondaryColor: data?.secondary_color,
        
        fiscalYearStartMonth: data?.fiscal_year_start_month,
        currency: data?.currency,
        timezone: data?.timezone,
        
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    }
  }
};

export default companySettingsService;